module.exports = __webpack_public_path__ + "static/media/manager.9c830647.jpg";